export default __webpack_public_path__ + "static/media/addIcon.1c5ad96d.svg";